<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.10002,2C8.03443,2.32311,8,2.65753,8,3C8,3.34247,8.03443,3.67689,8.10003,4C8.10003,4,3.66,4,3.66,4C3.66,4,1.95,8,1.95,8C1.95,8,4,8,4,8C4.55,8,5,8.45,5,9C5,9,5,10,5,10C5,10,11,10,11,10C11,10,11,9,11,9C11,8.45,11.45,8,12,8C12,8,13,8,13,8C13,8,14.05,8,14.05,8C14.7582,8,15.4021,7.75878,15.955,7.355C15.955,7.355,16,7.46,16,7.46C16,7.46,16,13,16,13C16,13.55,15.55,14,15,14C15,14,1,14,1,14C0.45,14,0,13.55,0,13C0,13,0,7.46,0,7.46C0,7.46,2.08,2.61,2.08,2.61C2.23,2.25,2.59,2,3,2C3,2,8.10002,2,8.10002,2C8.10002,2,8.10002,2,8.10002,2ZM13,6C11.3431,6,10,4.65685,10,3C10,1.34315,11.3431,0,13,0C14.6569,0,16,1.34315,16,3C16,4.65685,14.6569,6,13,6C13,6,13,6,13,6Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'InboxUpdate',
} as DefineComponent
</script>
